<template>
  <v-card :class="isMobile ? 'table-card pl-2 pr-2' : 'table-card'" elevation="0">
    <v-card-title class="pl-0 pt-0">
      {{ $t('queues.reports.agent.title') }}
    </v-card-title>
    <v-card-subtitle class="pl-0 pb-0 text-subtitle-1 font-weight-bold">
      {{ selectedAgent.name.split('|')[0] }}
    </v-card-subtitle>
    <v-card-subtitle class="pl-0 pt-0">
      <v-icon>mdi-calendar</v-icon>&nbsp;
      <span v-if="scope === 'day'"><strong>{{ startDate.substring(0, 10) }}</strong></span>
      <span v-else-if="scope === 'hour'" v-html="$t('queues.reports.scopeDisplays.hour',
        { date: startDate.substring(0, 10), start: startDate.substring(11, 19), end: endDate.substring(11, 19) })" />
      <span v-else v-html="$t('queues.reports.scopeDisplays.range', { start: startDate, end: endDate })"></span>
    </v-card-subtitle>
    <v-data-table
      :headers="headers"
      :items="reportRows.result"
      :options.sync="pagination"
      :server-items-length="pagination.totalItems"
      :loading="loading"
      :disable-sort="true"
      :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
      class="report-table"
      >
      <template v-slot:item.time="{ item }">
        {{ formatDate(item.time) }}
      </template>
      <template v-slot:item.callerId="{ item }">
        {{ formatClid(item.callerId) }}
      </template>
      <template v-slot:item.holdtime="{ item }">
        {{ hourTemplate(item.holdtime) }}
      </template>
      <template v-slot:item.callDuration="{ item }">
        <span v-if="item.event === 'RINGCANCELED' || item.event === 'RINGNOANSWER'"><v-icon>mdi-phone-remove</v-icon></span>
        <span v-else>{{ hourTemplate(item.callDuration) }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn v-if="item.recording && item.cdr_id" icon color="primary" @click="$emit('playRecording', item.cdr_id)">
          <v-icon>mdi-play</v-icon>
        </v-btn>
        <v-btn icon color="primary" @click="$refs.callDialog.loadCallDetails(item.callid)">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <CallDetailsDialog :scope="scope" :timezone="timezone" ref="callDialog" />
  </v-card>
</template>

<script>
import formatPhoneNum from '@/filters/phone_num'
import { formatDateReduced } from '@/filters/format_date'
import formatTime from '@/filters/format_time'
import CallDetailsDialog from './call_details_dialog'

export default {
  name: 'queues-reports-agent-details',
  components: { CallDetailsDialog },
  props: {
    reportRows: {
      type: Object,
      required: true
    },
    scope: {
      type: String,
      default: 'month'
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    timezone: {
      type: String,
      default: 'UTC'
    }
  },
  data () {
    return {
      loading: false,
      isWatcherActive: false,
      pagination: {
        page: 1,
        itemsPerPage: 25,
        totalItems: 0
      }
    }
  },
  mounted () {
    this.pagination.totalItems = this.reportRows.total || 0
    this.$nextTick(() => {
      this.isWatcherActive = true
    })
  },
  watch: {
    pagination: {
      handler () {
        if (this.isWatcherActive) this.load()
      },
      deep: true
    },
    reportRows: {
      immediate: true,
      handler (newVal) {
        this.pagination.totalItems = newVal.total
      }
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    },
    headers () {
      return [
        { text: this.$t('queues.reports.agent.details.time'), value: 'time', width: 150 },
        { text: this.$t('queues.reports.agent.details.callerId'), value: 'callerId' },
        { text: this.$t('queues.reports.agent.details.queue'), value: 'queuename' },
        { text: this.$t('queues.reports.agent.details.holdTime'), value: 'holdtime', align: 'center', width: 120 },
        { text: this.$t('queues.reports.agent.details.duration'), value: 'callDuration', align: 'center', width: 120 },
        { text: '', value: 'actions', sortable: false, align: 'end', width: 105 }
      ]
    },
    selectedAgent () {
      if (!this.reportRows.result?.length) return { name: '' }
      const firstAgent = this.reportRows.result[0]
      if (!firstAgent) return { name: '' }
      return { extension: firstAgent.agent.split('@')[0], name: firstAgent.agent_display }
    }
  },
  methods: {
    load () {
      this.loading = true
      try {
        this.$emit('refreshData', {
          reportType: 'agentDetails',
          agentExtension: this.selectedAgent?.extension,
          startDate: this.startDate,
          endDate: this.endDate,
          limit: this.pagination.itemsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.itemsPerPage
        })
      } catch (e) {
        this.dbg(e.response)
      } finally {
        this.loading = false
      }
    },
    formatClid (clid) {
      if (!clid) {
        return ''
      } else if (clid.indexOf('"') !== -1) {
        return clid.replaceAll('"', '')
      } else {
        return formatPhoneNum(clid)
      }
    },
    hourTemplate (seconds) {
      if (!seconds) return ''
      return formatTime(seconds)
    },
    formatDate (date) {
      if (this.$i18n.locale === 'en-US') return formatDateReduced(date, this.scope, this.$i18n.locale, false, true)
      return formatDateReduced(date, this.scope, this.$i18n.locale, false)
    }
  }
}
</script>
